import Api from '@/services/Api'
import ApiTraccar from '@/services/ApiTraccar'

export default {
  // Método que llama a la url para crear un chat
 getDevices () {
   return Api().get("/user-devices");
},
  getDevicesLocation (params) {
    return Api().get("/user-devices-location/"+params);
  },
  getDevicesLocationTraccar (params) {
    return ApiTraccar().get("/positions?deviceId="+params);
  },
  getDevicesLocationTraccarReport (params) {
    return ApiTraccar().get("/positions?"+params);
  },
  getDevicesLocationTraccarLastRely (params) {
    return ApiTraccar().get("/positions/last-rely-position?"+params);
  },
  getDevicesLocationStopsTraccarReport (params) {
    return ApiTraccar().get("/reports/stops?"+params);
  },
  getDevicesLocationTraccarAlarm (params) {
    return ApiTraccar().get("/events?"+params);
  },
  sendDeviceAction (params) {
    return Api().post("user-devices-action",params);
  },
  sendDeviceActionTraccar (params) {
    return ApiTraccar().post("commands/send",params);
  },
  updateAccumulatorsTraccar (params) {
    //https://demo.traccar.org/api/devices/{id}/accumulators
    return ApiTraccar().put("devices/"+params.deviceId+"/accumulators", params);
  },

  updateDevice (params) {
    return Api().put("/user-devices",params);
  },
  addDevice (params) {
    return Api().post("/user-devices",params);
  },
  addDeviceTraccar (params) {
    return ApiTraccar().post("/devices",params);
  },
  updateDeviceTraccar (params) {
    return ApiTraccar().put("/devices/"+params.id,params);
  },
  deleteDeviceTraccar (params) {
    return ApiTraccar().delete("/devices/"+params);
  },
  getDeviceTraccar (params) {
    return ApiTraccar().get("/devices/"+params);
  },
  getDevice (params) {
    return Api().get("/user-devices/"+params);
  },
  getDevicesByUserLogin (params) {
    return Api().get("/devices-by-userlogin/"+params);
  },
  getRelatedDevicesByUserLogin (params) {
    return Api().get("/related-devices-by-userlogin/"+params);
  },
  getRelatedDevicesByUserLoginFull (params) {
    return Api().get("/related-devices-by-userlogin-full/"+params);
  },
  deleteDevice (params) {
    return Api().delete("/user-devices/"+params);
  },
  getDeviceReport(params){
    return Api().post("user-devices-report",params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DeviceService.js